// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BotBilling — per-agent billing (/billing/:botId).
   Tier cards follow the rk- pricing design (PRICING-EXTRACT). Design tokens are
   scoped to .bbp-page so they can't leak globally. --app-primary is set to the
   Ultimo Bots brand purple (flip it to #18181b for the original monochrome look). */

.bbp-page {
  /* design tokens (scoped) */
  --app-primary: #5616ea;
  --app-primary-hover: #4a14d6;
  --app-primary-contrast: #ffffff;
  --app-bg: #f1f1f3;
  --app-surface: #ffffff;
  --app-text: #18181b;
  --app-text-muted: #63636b;
  --app-border: #e2e2e6;
  --app-border-hover: #c9c9cf;
  --app-success: #16a34a;
  --app-danger: #dc2626;
  --app-radius: 10px;
  --app-radius-card: 10px;
  --ease-smooth: cubic-bezier(0.25, 0.46, 0.45, 0.94);

  font-family: "DM Sans", sans-serif;
  max-width: 1100px;
  margin: 0;
  padding: 28px 24px 56px;
  box-sizing: border-box;
  color: var(--app-text);
}

.bbp-page .loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 320px;
}
.bbp-page .main-loading-spinner { font-size: 28px; color: var(--app-primary); }

/* ── Back link ───────────────────────────────────────────────────────── */
.bbp-back {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: none;
  background: transparent;
  color: var(--app-primary);
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  padding: 0;
  margin-bottom: 10px;
  cursor: pointer;
}
.bbp-back:hover { color: var(--app-primary-hover); text-decoration: underline; }
.bbp-back svg { font-size: 11px; }

/* ── Banners ─────────────────────────────────────────────────────────── */
.bbp-error,
.bbp-pastdue {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
  padding: 12px 14px;
  border-radius: 10px;
  font-size: 14px;
}
.bbp-error { background: #fef2f2; border: 1px solid #fecaca; color: #b91c1c; }
.bbp-error button { border: none; background: transparent; color: #b91c1c; cursor: pointer; font-size: 15px; }
.bbp-pastdue { background: #fff7ed; border: 1px solid #fed7aa; color: #9a3412; }
.bbp-pastdue button {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: none;
  background: var(--app-primary);
  color: #fff;
  font-weight: 600;
  font-size: 13px;
  padding: 8px 14px;
  border-radius: 10px;
  cursor: pointer;
}
.bbp-pastdue button:hover { background: var(--app-primary-hover); }
.bbp-pastdue button:disabled { opacity: 0.6; cursor: default; }

/* ════════════════════════════════════════════════════════════════════════
   rk- pricing design (cards + toggle), left-aligned within the page.
   ════════════════════════════════════════════════════════════════════════ */
.rk-billing { color: var(--app-text); }

/* Monthly / Yearly segment — the white thumb glides between the two. */
.rk-billing-toggle {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 224px;
  margin: 6px auto 0;
  background: var(--app-bg);
  border: 1px solid var(--app-border);
  border-radius: 999px;
  padding: 3px;
}
.rk-billing-toggle button {
  position: relative;
  z-index: 1;
  border: none;
  background: none;
  font: inherit;
  font-size: 13.5px;
  font-weight: 600;
  color: var(--app-text-muted);
  padding: 7px 0;
  cursor: pointer;
  border-radius: 999px;
  transition: color 0.25s var(--ease-smooth);
}
.rk-billing-toggle button.active { color: var(--app-text); }
.rk-billing-thumb {
  position: absolute;
  /* border-box so the 1px border is INSIDE width: calc(50% - 3px); otherwise
     (default content-box) the border inflates the thumb's real width and
     translateX(100%) over-moves, pushing the "Yearly" thumb too far right. */
  box-sizing: border-box;
  top: 3px;
  bottom: 3px;
  left: 3px;
  width: calc(50% - 3px);
  background: var(--app-surface);
  border-radius: 999px;
  border: 1px solid var(--app-border);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.28s var(--ease-smooth);
}
.rk-billing-thumb.right { transform: translateX(100%); }

/* Card grid — 3 across on desktop, stacks on mobile. */
.rk-plans {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(252px, 1fr));
  gap: 14px;
  align-items: stretch;
  margin-top: 28px;
}
.rk-plan {
  position: relative;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--app-border);
  border-radius: var(--app-radius-card);
  background: var(--app-surface);
  padding: 20px;
  transition: border-color 0.2s var(--ease-smooth), box-shadow 0.2s var(--ease-smooth);
}
.rk-plan:hover { border-color: var(--app-border-hover); }
/* Lift the active card above its neighbours so an open logo popover (hover or
   click/focus) is never clipped by an adjacent card. */
.rk-plan:hover,
.rk-plan:focus-within { z-index: 5; }
.rk-plan.featured,
.rk-plan.current {
  border-color: var(--app-primary);
  box-shadow: 0 0 0 1px var(--app-primary) inset;
}
.rk-plan-flag {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--app-primary);
  color: var(--app-primary-contrast);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  border-radius: 10px;
  padding: 3px 11px;
  white-space: nowrap;
}
.rk-plan-name { font-size: 14.5px; font-weight: 600; color: var(--app-text); }

/* Price. */
.rk-plan-price {
  font-size: 28px;
  font-weight: 800;
  color: var(--app-text);
  margin: 4px 0 14px;
  line-height: 1.1;
  animation: rk-fade-in 0.25s var(--ease-smooth);
}
.rk-plan-price span {
  font-size: 13px;
  font-weight: 400;
  color: var(--app-text-muted);
  margin-left: 5px;
}
.rk-plan-old { font-size: 15px; font-weight: 600; color: var(--app-text-muted); margin-right: 7px; }
.rk-plan-arrow { font-size: 15px; font-weight: 400; color: var(--app-text-muted); margin-right: 7px; }
.rk-plan-price .rk-plan-save {
  display: inline-block;
  margin-left: 9px;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.2px;
  background: var(--app-success);
  color: var(--app-primary-contrast);
  border-radius: 10px;
  padding: 2.5px 8px;
  vertical-align: 4px;
}
.rk-plan-billed {
  font-size: 12px;
  color: var(--app-text-muted);
  margin: -10px 0 14px;
  animation: rk-fade-in 0.25s var(--ease-smooth);
}
@keyframes rk-fade-in {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: none; }
}

/* Spec rows (icon + label + value). */
.rk-plan-limits { margin-bottom: 16px; }
.rk-plan-limit {
  display: flex;
  align-items: center;
  gap: 11px;
  font-size: 13.5px;
  color: var(--app-text);
  padding: 6px 0;
}
.rk-plan-limit svg { width: 16px; text-align: center; font-size: 13px; opacity: 0.75; flex: 0 0 auto; }
.rk-plan-limit span { flex: 1 1; }
.rk-plan-limit strong { font-weight: 700; font-variant-numeric: tabular-nums; }

/* CTA button. */
.rk-plan-cta {
  width: 100%;
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  padding: 9px 14px;
  border-radius: var(--app-radius);
  cursor: pointer;
  border: 1px solid var(--app-border);
  background: var(--app-surface);
  color: var(--app-text);
  transition: background 0.15s var(--ease-smooth), border-color 0.15s var(--ease-smooth), color 0.15s var(--ease-smooth);
}
.rk-plan-cta:hover:not(:disabled) { background: var(--app-bg); border-color: var(--app-border-hover); }
.rk-plan-cta.featured {
  background: var(--app-primary);
  color: var(--app-primary-contrast);
  border-color: var(--app-primary);
}
.rk-plan-cta.featured:hover:not(:disabled) { background: var(--app-primary-hover); border-color: var(--app-primary-hover); }
.rk-plan-cta.danger {
  background: var(--app-surface);
  color: var(--app-danger);
  border-color: color-mix(in srgb, var(--app-danger) 40%, var(--app-border));
}
.rk-plan-cta.danger:hover:not(:disabled) {
  border-color: var(--app-danger);
  background: color-mix(in srgb, var(--app-danger) 8%, var(--app-surface));
}
.rk-plan-cta:disabled { cursor: default; opacity: 0.65; background: var(--app-surface); border-color: var(--app-border); color: var(--app-text-muted); }
.rk-plan-cancel { margin-top: 8px; }

/* "Cancelled, active until <date>" notice on the current plan card. */
.rk-plan-ending {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
  padding: 8px 11px;
  border-radius: 10px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  color: #9a3412;
  font-size: 12.5px;
  font-weight: 600;
  line-height: 1.35;
}
.rk-plan-ending svg { font-size: 12px; flex: 0 0 auto; }

/* Divider + section header. */
.rk-plan-div { border-top: 1px solid var(--app-border); margin: 16px 0 12px; }
.rk-plan-sec {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: var(--app-text-muted);
  margin-bottom: 10px;
}

/* Feature checklist. */
.rk-plan-feats { list-style: none; margin: 0; padding: 0; }
.rk-plan-feats li {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: var(--app-text);
  padding: 5px 0;
}
.rk-plan-feats li svg { width: 14px; font-size: 11px; flex: 0 0 auto; text-align: center; }
.rk-plan-feats li .rk-feat-ok { color: var(--app-primary); }
.rk-plan-feats li.off { color: var(--app-text-muted); opacity: 0.7; }

/* ── Apps / Channels logo rows (styled like the AI-models screenshot) ──── */
.rk-logo-row { position: relative; }
.rk-logos { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; }
.rk-logo {
  position: relative;
  width: 30px;
  height: 30px;
  border-radius: 10px;
  border: 1px solid var(--app-border);
  background: var(--app-surface);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}
.rk-logo img { width: 19px; height: 19px; object-fit: contain; display: block; }
.rk-logo svg { font-size: 15px; color: var(--app-text); }

/* Hover tooltip with the app/channel name (dark pill + arrow, fades in). */
.rk-logo::after {
  content: attr(data-tip);
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%) translateY(4px);
  background: var(--app-text);
  color: #fff;
  font-size: 11.5px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  padding: 6px 9px;
  border-radius: 10px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s var(--ease-smooth), transform 0.15s var(--ease-smooth);
  z-index: 40;
}
.rk-logo::before {
  content: "";
  position: absolute;
  bottom: calc(100% + 3px);
  left: 50%;
  transform: translateX(-50%) translateY(4px);
  border: 5px solid transparent;
  border-top-color: var(--app-text);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s var(--ease-smooth), transform 0.15s var(--ease-smooth);
  z-index: 40;
}
.rk-logo:hover::after,
.rk-logo:hover::before { opacity: 1; transform: translateX(-50%) translateY(0); }

/* Inside the "+N" popover each item already shows its name — no tooltip there. */
.rk-logo-pop .rk-logo::after,
.rk-logo-pop .rk-logo::before { display: none; }
.rk-logo-more {
  width: 30px;
  height: 30px;
  border-radius: 10px;
  border: 1px dashed var(--app-border-hover);
  background: var(--app-bg);
  color: var(--app-text-muted);
  font: inherit;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  flex: 0 0 auto;
  transition: border-color 0.15s var(--ease-smooth), color 0.15s var(--ease-smooth);
}
.rk-logo-more:hover { border-color: var(--app-primary); color: var(--app-primary); }
.rk-logo-more-wrap { position: relative; display: inline-flex; }
.rk-logo-pop {
  position: absolute;
  z-index: 30;
  top: calc(100% + 8px);
  right: 0;
  min-width: 200px;
  max-width: 240px;
  background: var(--app-surface);
  border: 1px solid var(--app-border);
  border-radius: 10px;
  box-shadow: 0 18px 40px -16px rgba(0, 0, 0, 0.3);
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  /* The full channel list is long, so cap the popover height and let it scroll
     instead of running off the screen. */
  max-height: 280px;
  overflow-y: auto;
  overscroll-behavior: contain;
}
/* Flipped: opens above the chip when there is no room below (scroll container / viewport). */
.rk-logo-pop.up { top: auto; bottom: calc(100% + 8px); box-shadow: 0 -18px 40px -16px rgba(0, 0, 0, 0.3); }
.rk-logo-pop-item { display: flex; align-items: center; gap: 10px; font-size: 13px; color: var(--app-text); }
.rk-logo-pop-label { white-space: nowrap; }

/* ── Wix-managed view ────────────────────────────────────────────────── */
/* Full-width card (matches the usage meter above). Left-aligned header with the
   action on the right, then the two stat tiles filling the width below — so the
   content uses the whole card instead of floating in a narrow centered column. */
.bbp-wix {
  margin: 12px 0 0;
  display: flex;
  flex-direction: column;
  gap: 22px;
  text-align: left;
  background: var(--app-surface);
  border: 1px solid var(--app-border);
  border-radius: 10px;
  padding: 24px 26px;
}
.bbp-wix-head {
  display: flex;
  align-items: center;
  gap: 20px;
}
.bbp-wix-headmain {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.bbp-wix-badge {
  align-self: flex-start;
  margin-bottom: 12px;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.04em;
  color: #0c6efd;
  background: #e7f0ff;
  padding: 5px 14px;
  border-radius: 10px;
}
.bbp-wix-title { margin: 0 0 6px; font-size: 19px; font-weight: 700; color: var(--app-text); }
.bbp-wix-text { margin: 0; font-size: 14px; line-height: 1.5; color: var(--app-text-muted); max-width: 560px; }
.bbp-wix-status { display: flex; gap: 14px; }
.bbp-wix-stat {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 14px 16px;
  background: var(--app-bg);
  border: 1px solid var(--app-border);
  border-radius: 10px;
}
.bbp-wix-stat span { font-size: 11.5px; font-weight: 600; letter-spacing: 0.03em; text-transform: uppercase; color: var(--app-text-muted); }
.bbp-wix-stat strong { font-size: 15px; color: var(--app-text); }
.bbp-wix-btn {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  border: none;
  background: var(--app-primary);
  color: #fff;
  font-family: inherit;
  font-size: 14.5px;
  font-weight: 700;
  padding: 11px 26px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s var(--ease-smooth);
}
.bbp-wix-btn:hover:not(:disabled) { background: var(--app-primary-hover); }
.bbp-wix-btn:disabled { opacity: 0.65; cursor: default; }
.bbp-wix-btn svg { font-size: 12px; }

/* Shared status pill (Wix view). */
.bbp-status { display: inline-flex; align-items: center; gap: 7px; }
.bbp-status-dot { width: 8px; height: 8px; border-radius: 50%; background: #9ca3af; flex: 0 0 auto; }
.bbp-status.active .bbp-status-dot,
.bbp-status.trialing .bbp-status-dot { background: #22c55e; }
.bbp-status.ending .bbp-status-dot { background: #f59e0b; }
.bbp-status.past-due .bbp-status-dot,
.bbp-status.cancelled .bbp-status-dot { background: #ef4444; }
.bbp-status.free .bbp-status-dot { background: #c4b5fd; }

/* ── Not found ───────────────────────────────────────────────────────── */
.bbp-notfound {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 60px 24px;
  text-align: center;
  color: var(--app-text-muted);
}

/* ── Responsive ──────────────────────────────────────────────────────── */
@media (max-width: 720px) {
  .rk-plans { grid-template-columns: 1fr; max-width: 420px; }
  /* Stack the Wix header (button drops below the text, full-width) + the stats. */
  .bbp-wix-head { flex-direction: column; align-items: stretch; gap: 16px; }
  .bbp-wix-btn { justify-content: center; }
  .bbp-wix-status { flex-direction: column; align-items: stretch; }
}

/* Shopify-managed billing: the Wix panel pattern with the Shopify badge color. */
.bbp-wix-badge.bbp-badge-shopify { background: #e8f6ee; color: #157347; }
`, "",{"version":3,"sources":["webpack://./src/pages/BotBilling.css"],"names":[],"mappings":"AAAA;;;oFAGoF;;AAEpF;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;EAC/B,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,mDAAmD;;EAEnD,kCAAkC;EAClC,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;AACA,kCAAkC,eAAe,EAAE,yBAAyB,EAAE;;AAE9E,2EAA2E;AAC3E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,eAAe;AACjB;AACA,kBAAkB,+BAA+B,EAAE,0BAA0B,EAAE;AAC/E,gBAAgB,eAAe,EAAE;;AAEjC,2EAA2E;AAC3E;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;AACA,aAAa,mBAAmB,EAAE,yBAAyB,EAAE,cAAc,EAAE;AAC7E,oBAAoB,YAAY,EAAE,uBAAuB,EAAE,cAAc,EAAE,eAAe,EAAE,eAAe,EAAE;AAC7G,eAAe,mBAAmB,EAAE,yBAAyB,EAAE,cAAc,EAAE;AAC/E;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;AACA,4BAA4B,oCAAoC,EAAE;AAClE,+BAA+B,YAAY,EAAE,eAAe,EAAE;;AAE9D;;6EAE6E;AAC7E,cAAc,sBAAsB,EAAE;;AAEtC,uEAAuE;AACvE;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,0CAA0C;AAC5C;AACA,mCAAmC,sBAAsB,EAAE;AAC3D;EACE,kBAAkB;EAClB;;6EAE2E;EAC3E,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,8BAA8B;EAC9B,oBAAoB;EACpB,mCAAmC;EACnC,wCAAwC;EACxC,8CAA8C;AAChD;AACA,0BAA0B,2BAA2B,EAAE;;AAEvD,uDAAuD;AACvD;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,qCAAqC;EACrC,8BAA8B;EAC9B,aAAa;EACb,oFAAoF;AACtF;AACA,iBAAiB,qCAAqC,EAAE;AACxD;uDACuD;AACvD;wBACwB,UAAU,EAAE;AACpC;;EAEE,gCAAgC;EAChC,8CAA8C;AAChD;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;AACA,gBAAgB,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;;AAE7E,WAAW;AACX;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA,eAAe,eAAe,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,iBAAiB,EAAE;AACnG,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,iBAAiB,EAAE;AACrG;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,oBAAoB;EACpB,8CAA8C;AAChD;AACA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA,sCAAsC;AACtC,kBAAkB,mBAAmB,EAAE;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA,qBAAqB,WAAW,EAAE,kBAAkB,EAAE,eAAe,EAAE,aAAa,EAAE,cAAc,EAAE;AACtG,sBAAsB,SAAO,EAAE;AAC/B,wBAAwB,gBAAgB,EAAE,kCAAkC,EAAE;;AAE9E,gBAAgB;AAChB;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,mCAAmC;EACnC,8BAA8B;EAC9B,sBAAsB;EACtB,sHAAsH;AACxH;AACA,oCAAoC,yBAAyB,EAAE,qCAAqC,EAAE;AACtG;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,gCAAgC;AAClC;AACA,6CAA6C,oCAAoC,EAAE,sCAAsC,EAAE;AAC3H;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,0EAA0E;AAC5E;AACA;EACE,+BAA+B;EAC/B,wEAAwE;AAC1E;AACA,wBAAwB,eAAe,EAAE,aAAa,EAAE,8BAA8B,EAAE,+BAA+B,EAAE,4BAA4B,EAAE;AACvJ,kBAAkB,eAAe,EAAE;;AAEnC,sEAAsE;AACtE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA,sBAAsB,eAAe,EAAE,cAAc,EAAE;;AAEvD,8BAA8B;AAC9B,eAAe,uCAAuC,EAAE,mBAAmB,EAAE;AAC7E;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB,iBAAiB,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE;AAC1D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;AACA,wBAAwB,WAAW,EAAE,eAAe,EAAE,cAAc,EAAE,kBAAkB,EAAE;AAC1F,gCAAgC,yBAAyB,EAAE;AAC3D,wBAAwB,4BAA4B,EAAE,YAAY,EAAE;;AAEpE,6EAA6E;AAC7E,eAAe,kBAAkB,EAAE;AACnC,YAAY,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE;AAC3E;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA,eAAe,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC/E,eAAe,eAAe,EAAE,sBAAsB,EAAE;;AAExD,2EAA2E;AAC3E;EACE,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2CAA2C;EAC3C,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,gFAAgF;EAChF,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2CAA2C;EAC3C,6BAA6B;EAC7B,iCAAiC;EACjC,UAAU;EACV,oBAAoB;EACpB,gFAAgF;EAChF,WAAW;AACb;AACA;yBACyB,UAAU,EAAE,yCAAyC,EAAE;;AAEhF,iFAAiF;AACjF;gCACgC,aAAa,EAAE;AAC/C;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,4BAA4B;EAC5B,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iFAAiF;AACnF;AACA,sBAAsB,gCAAgC,EAAE,yBAAyB,EAAE;AACnF,qBAAqB,kBAAkB,EAAE,oBAAoB,EAAE;AAC/D;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,mCAAmC;EACnC,mBAAmB;EACnB,gDAAgD;EAChD,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR;yCACuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA,6FAA6F;AAC7F,kBAAkB,SAAS,EAAE,wBAAwB,EAAE,iDAAiD,EAAE;AAC1G,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE,sBAAsB,EAAE;AAC5G,qBAAqB,mBAAmB,EAAE;;AAE1C,2EAA2E;AAC3E;;iFAEiF;AACjF;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,8BAA8B;EAC9B,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;AACA,iBAAiB,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AAC7F,gBAAgB,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;AAC9G,kBAAkB,aAAa,EAAE,SAAS,EAAE;AAC5C;EACE,SAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,mBAAmB;AACrB;AACA,qBAAqB,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,yBAAyB,EAAE,4BAA4B,EAAE;AAC3I,uBAAuB,eAAe,EAAE,sBAAsB,EAAE;AAChE;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,8BAA8B;EAC9B,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,+CAA+C;AACjD;AACA,oCAAoC,oCAAoC,EAAE;AAC1E,wBAAwB,aAAa,EAAE,eAAe,EAAE;AACxD,mBAAmB,eAAe,EAAE;;AAEpC,mCAAmC;AACnC,cAAc,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACnE,kBAAkB,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACpG;uCACuC,mBAAmB,EAAE;AAC5D,qCAAqC,mBAAmB,EAAE;AAC1D;wCACwC,mBAAmB,EAAE;AAC7D,mCAAmC,mBAAmB,EAAE;;AAExD,2EAA2E;AAC3E;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,2EAA2E;AAC3E;EACE,YAAY,0BAA0B,EAAE,gBAAgB,EAAE;EAC1D,gFAAgF;EAChF,gBAAgB,sBAAsB,EAAE,oBAAoB,EAAE,SAAS,EAAE;EACzE,eAAe,uBAAuB,EAAE;EACxC,kBAAkB,sBAAsB,EAAE,oBAAoB,EAAE;AAClE;;AAEA,iFAAiF;AACjF,mCAAmC,mBAAmB,EAAE,cAAc,EAAE","sourcesContent":["/* BotBilling — per-agent billing (/billing/:botId).\r\n   Tier cards follow the rk- pricing design (PRICING-EXTRACT). Design tokens are\r\n   scoped to .bbp-page so they can't leak globally. --app-primary is set to the\r\n   Ultimo Bots brand purple (flip it to #18181b for the original monochrome look). */\r\n\r\n.bbp-page {\r\n  /* design tokens (scoped) */\r\n  --app-primary: #5616ea;\r\n  --app-primary-hover: #4a14d6;\r\n  --app-primary-contrast: #ffffff;\r\n  --app-bg: #f1f1f3;\r\n  --app-surface: #ffffff;\r\n  --app-text: #18181b;\r\n  --app-text-muted: #63636b;\r\n  --app-border: #e2e2e6;\r\n  --app-border-hover: #c9c9cf;\r\n  --app-success: #16a34a;\r\n  --app-danger: #dc2626;\r\n  --app-radius: 10px;\r\n  --app-radius-card: 10px;\r\n  --ease-smooth: cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n\r\n  font-family: \"DM Sans\", sans-serif;\r\n  max-width: 1100px;\r\n  margin: 0;\r\n  padding: 28px 24px 56px;\r\n  box-sizing: border-box;\r\n  color: var(--app-text);\r\n}\r\n\r\n.bbp-page .loading-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 320px;\r\n}\r\n.bbp-page .main-loading-spinner { font-size: 28px; color: var(--app-primary); }\r\n\r\n/* ── Back link ───────────────────────────────────────────────────────── */\r\n.bbp-back {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  border: none;\r\n  background: transparent;\r\n  color: var(--app-primary);\r\n  font-family: inherit;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  padding: 0;\r\n  margin-bottom: 10px;\r\n  cursor: pointer;\r\n}\r\n.bbp-back:hover { color: var(--app-primary-hover); text-decoration: underline; }\r\n.bbp-back svg { font-size: 11px; }\r\n\r\n/* ── Banners ─────────────────────────────────────────────────────────── */\r\n.bbp-error,\r\n.bbp-pastdue {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  margin-bottom: 18px;\r\n  padding: 12px 14px;\r\n  border-radius: 10px;\r\n  font-size: 14px;\r\n}\r\n.bbp-error { background: #fef2f2; border: 1px solid #fecaca; color: #b91c1c; }\r\n.bbp-error button { border: none; background: transparent; color: #b91c1c; cursor: pointer; font-size: 15px; }\r\n.bbp-pastdue { background: #fff7ed; border: 1px solid #fed7aa; color: #9a3412; }\r\n.bbp-pastdue button {\r\n  flex: 0 0 auto;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  border: none;\r\n  background: var(--app-primary);\r\n  color: #fff;\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n  padding: 8px 14px;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n}\r\n.bbp-pastdue button:hover { background: var(--app-primary-hover); }\r\n.bbp-pastdue button:disabled { opacity: 0.6; cursor: default; }\r\n\r\n/* ════════════════════════════════════════════════════════════════════════\r\n   rk- pricing design (cards + toggle), left-aligned within the page.\r\n   ════════════════════════════════════════════════════════════════════════ */\r\n.rk-billing { color: var(--app-text); }\r\n\r\n/* Monthly / Yearly segment — the white thumb glides between the two. */\r\n.rk-billing-toggle {\r\n  position: relative;\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  width: 224px;\r\n  margin: 6px auto 0;\r\n  background: var(--app-bg);\r\n  border: 1px solid var(--app-border);\r\n  border-radius: 999px;\r\n  padding: 3px;\r\n}\r\n.rk-billing-toggle button {\r\n  position: relative;\r\n  z-index: 1;\r\n  border: none;\r\n  background: none;\r\n  font: inherit;\r\n  font-size: 13.5px;\r\n  font-weight: 600;\r\n  color: var(--app-text-muted);\r\n  padding: 7px 0;\r\n  cursor: pointer;\r\n  border-radius: 999px;\r\n  transition: color 0.25s var(--ease-smooth);\r\n}\r\n.rk-billing-toggle button.active { color: var(--app-text); }\r\n.rk-billing-thumb {\r\n  position: absolute;\r\n  /* border-box so the 1px border is INSIDE width: calc(50% - 3px); otherwise\r\n     (default content-box) the border inflates the thumb's real width and\r\n     translateX(100%) over-moves, pushing the \"Yearly\" thumb too far right. */\r\n  box-sizing: border-box;\r\n  top: 3px;\r\n  bottom: 3px;\r\n  left: 3px;\r\n  width: calc(50% - 3px);\r\n  background: var(--app-surface);\r\n  border-radius: 999px;\r\n  border: 1px solid var(--app-border);\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  transition: transform 0.28s var(--ease-smooth);\r\n}\r\n.rk-billing-thumb.right { transform: translateX(100%); }\r\n\r\n/* Card grid — 3 across on desktop, stacks on mobile. */\r\n.rk-plans {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(252px, 1fr));\r\n  gap: 14px;\r\n  align-items: stretch;\r\n  margin-top: 28px;\r\n}\r\n.rk-plan {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border: 1px solid var(--app-border);\r\n  border-radius: var(--app-radius-card);\r\n  background: var(--app-surface);\r\n  padding: 20px;\r\n  transition: border-color 0.2s var(--ease-smooth), box-shadow 0.2s var(--ease-smooth);\r\n}\r\n.rk-plan:hover { border-color: var(--app-border-hover); }\r\n/* Lift the active card above its neighbours so an open logo popover (hover or\r\n   click/focus) is never clipped by an adjacent card. */\r\n.rk-plan:hover,\r\n.rk-plan:focus-within { z-index: 5; }\r\n.rk-plan.featured,\r\n.rk-plan.current {\r\n  border-color: var(--app-primary);\r\n  box-shadow: 0 0 0 1px var(--app-primary) inset;\r\n}\r\n.rk-plan-flag {\r\n  position: absolute;\r\n  top: -10px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  background: var(--app-primary);\r\n  color: var(--app-primary-contrast);\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.4px;\r\n  text-transform: uppercase;\r\n  border-radius: 10px;\r\n  padding: 3px 11px;\r\n  white-space: nowrap;\r\n}\r\n.rk-plan-name { font-size: 14.5px; font-weight: 600; color: var(--app-text); }\r\n\r\n/* Price. */\r\n.rk-plan-price {\r\n  font-size: 28px;\r\n  font-weight: 800;\r\n  color: var(--app-text);\r\n  margin: 4px 0 14px;\r\n  line-height: 1.1;\r\n  animation: rk-fade-in 0.25s var(--ease-smooth);\r\n}\r\n.rk-plan-price span {\r\n  font-size: 13px;\r\n  font-weight: 400;\r\n  color: var(--app-text-muted);\r\n  margin-left: 5px;\r\n}\r\n.rk-plan-old { font-size: 15px; font-weight: 600; color: var(--app-text-muted); margin-right: 7px; }\r\n.rk-plan-arrow { font-size: 15px; font-weight: 400; color: var(--app-text-muted); margin-right: 7px; }\r\n.rk-plan-price .rk-plan-save {\r\n  display: inline-block;\r\n  margin-left: 9px;\r\n  font-size: 11.5px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.2px;\r\n  background: var(--app-success);\r\n  color: var(--app-primary-contrast);\r\n  border-radius: 10px;\r\n  padding: 2.5px 8px;\r\n  vertical-align: 4px;\r\n}\r\n.rk-plan-billed {\r\n  font-size: 12px;\r\n  color: var(--app-text-muted);\r\n  margin: -10px 0 14px;\r\n  animation: rk-fade-in 0.25s var(--ease-smooth);\r\n}\r\n@keyframes rk-fade-in {\r\n  from { opacity: 0; transform: translateY(8px); }\r\n  to { opacity: 1; transform: none; }\r\n}\r\n\r\n/* Spec rows (icon + label + value). */\r\n.rk-plan-limits { margin-bottom: 16px; }\r\n.rk-plan-limit {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 11px;\r\n  font-size: 13.5px;\r\n  color: var(--app-text);\r\n  padding: 6px 0;\r\n}\r\n.rk-plan-limit svg { width: 16px; text-align: center; font-size: 13px; opacity: 0.75; flex: 0 0 auto; }\r\n.rk-plan-limit span { flex: 1; }\r\n.rk-plan-limit strong { font-weight: 700; font-variant-numeric: tabular-nums; }\r\n\r\n/* CTA button. */\r\n.rk-plan-cta {\r\n  width: 100%;\r\n  font: inherit;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  padding: 9px 14px;\r\n  border-radius: var(--app-radius);\r\n  cursor: pointer;\r\n  border: 1px solid var(--app-border);\r\n  background: var(--app-surface);\r\n  color: var(--app-text);\r\n  transition: background 0.15s var(--ease-smooth), border-color 0.15s var(--ease-smooth), color 0.15s var(--ease-smooth);\r\n}\r\n.rk-plan-cta:hover:not(:disabled) { background: var(--app-bg); border-color: var(--app-border-hover); }\r\n.rk-plan-cta.featured {\r\n  background: var(--app-primary);\r\n  color: var(--app-primary-contrast);\r\n  border-color: var(--app-primary);\r\n}\r\n.rk-plan-cta.featured:hover:not(:disabled) { background: var(--app-primary-hover); border-color: var(--app-primary-hover); }\r\n.rk-plan-cta.danger {\r\n  background: var(--app-surface);\r\n  color: var(--app-danger);\r\n  border-color: color-mix(in srgb, var(--app-danger) 40%, var(--app-border));\r\n}\r\n.rk-plan-cta.danger:hover:not(:disabled) {\r\n  border-color: var(--app-danger);\r\n  background: color-mix(in srgb, var(--app-danger) 8%, var(--app-surface));\r\n}\r\n.rk-plan-cta:disabled { cursor: default; opacity: 0.65; background: var(--app-surface); border-color: var(--app-border); color: var(--app-text-muted); }\r\n.rk-plan-cancel { margin-top: 8px; }\r\n\r\n/* \"Cancelled, active until <date>\" notice on the current plan card. */\r\n.rk-plan-ending {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-top: 4px;\r\n  padding: 8px 11px;\r\n  border-radius: 10px;\r\n  background: #fff7ed;\r\n  border: 1px solid #fed7aa;\r\n  color: #9a3412;\r\n  font-size: 12.5px;\r\n  font-weight: 600;\r\n  line-height: 1.35;\r\n}\r\n.rk-plan-ending svg { font-size: 12px; flex: 0 0 auto; }\r\n\r\n/* Divider + section header. */\r\n.rk-plan-div { border-top: 1px solid var(--app-border); margin: 16px 0 12px; }\r\n.rk-plan-sec {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.5px;\r\n  text-transform: uppercase;\r\n  color: var(--app-text-muted);\r\n  margin-bottom: 10px;\r\n}\r\n\r\n/* Feature checklist. */\r\n.rk-plan-feats { list-style: none; margin: 0; padding: 0; }\r\n.rk-plan-feats li {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  font-size: 13px;\r\n  color: var(--app-text);\r\n  padding: 5px 0;\r\n}\r\n.rk-plan-feats li svg { width: 14px; font-size: 11px; flex: 0 0 auto; text-align: center; }\r\n.rk-plan-feats li .rk-feat-ok { color: var(--app-primary); }\r\n.rk-plan-feats li.off { color: var(--app-text-muted); opacity: 0.7; }\r\n\r\n/* ── Apps / Channels logo rows (styled like the AI-models screenshot) ──── */\r\n.rk-logo-row { position: relative; }\r\n.rk-logos { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; }\r\n.rk-logo {\r\n  position: relative;\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--app-border);\r\n  background: var(--app-surface);\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex: 0 0 auto;\r\n}\r\n.rk-logo img { width: 19px; height: 19px; object-fit: contain; display: block; }\r\n.rk-logo svg { font-size: 15px; color: var(--app-text); }\r\n\r\n/* Hover tooltip with the app/channel name (dark pill + arrow, fades in). */\r\n.rk-logo::after {\r\n  content: attr(data-tip);\r\n  position: absolute;\r\n  bottom: calc(100% + 8px);\r\n  left: 50%;\r\n  transform: translateX(-50%) translateY(4px);\r\n  background: var(--app-text);\r\n  color: #fff;\r\n  font-size: 11.5px;\r\n  font-weight: 600;\r\n  line-height: 1;\r\n  white-space: nowrap;\r\n  padding: 6px 9px;\r\n  border-radius: 10px;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  transition: opacity 0.15s var(--ease-smooth), transform 0.15s var(--ease-smooth);\r\n  z-index: 40;\r\n}\r\n.rk-logo::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  bottom: calc(100% + 3px);\r\n  left: 50%;\r\n  transform: translateX(-50%) translateY(4px);\r\n  border: 5px solid transparent;\r\n  border-top-color: var(--app-text);\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  transition: opacity 0.15s var(--ease-smooth), transform 0.15s var(--ease-smooth);\r\n  z-index: 40;\r\n}\r\n.rk-logo:hover::after,\r\n.rk-logo:hover::before { opacity: 1; transform: translateX(-50%) translateY(0); }\r\n\r\n/* Inside the \"+N\" popover each item already shows its name — no tooltip there. */\r\n.rk-logo-pop .rk-logo::after,\r\n.rk-logo-pop .rk-logo::before { display: none; }\r\n.rk-logo-more {\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 10px;\r\n  border: 1px dashed var(--app-border-hover);\r\n  background: var(--app-bg);\r\n  color: var(--app-text-muted);\r\n  font: inherit;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  flex: 0 0 auto;\r\n  transition: border-color 0.15s var(--ease-smooth), color 0.15s var(--ease-smooth);\r\n}\r\n.rk-logo-more:hover { border-color: var(--app-primary); color: var(--app-primary); }\r\n.rk-logo-more-wrap { position: relative; display: inline-flex; }\r\n.rk-logo-pop {\r\n  position: absolute;\r\n  z-index: 30;\r\n  top: calc(100% + 8px);\r\n  right: 0;\r\n  min-width: 200px;\r\n  max-width: 240px;\r\n  background: var(--app-surface);\r\n  border: 1px solid var(--app-border);\r\n  border-radius: 10px;\r\n  box-shadow: 0 18px 40px -16px rgba(0, 0, 0, 0.3);\r\n  padding: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  /* The full channel list is long, so cap the popover height and let it scroll\r\n     instead of running off the screen. */\r\n  max-height: 280px;\r\n  overflow-y: auto;\r\n  overscroll-behavior: contain;\r\n}\r\n/* Flipped: opens above the chip when there is no room below (scroll container / viewport). */\r\n.rk-logo-pop.up { top: auto; bottom: calc(100% + 8px); box-shadow: 0 -18px 40px -16px rgba(0, 0, 0, 0.3); }\r\n.rk-logo-pop-item { display: flex; align-items: center; gap: 10px; font-size: 13px; color: var(--app-text); }\r\n.rk-logo-pop-label { white-space: nowrap; }\r\n\r\n/* ── Wix-managed view ────────────────────────────────────────────────── */\r\n/* Full-width card (matches the usage meter above). Left-aligned header with the\r\n   action on the right, then the two stat tiles filling the width below — so the\r\n   content uses the whole card instead of floating in a narrow centered column. */\r\n.bbp-wix {\r\n  margin: 12px 0 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 22px;\r\n  text-align: left;\r\n  background: var(--app-surface);\r\n  border: 1px solid var(--app-border);\r\n  border-radius: 10px;\r\n  padding: 24px 26px;\r\n}\r\n.bbp-wix-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n}\r\n.bbp-wix-headmain {\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.bbp-wix-badge {\r\n  align-self: flex-start;\r\n  margin-bottom: 12px;\r\n  font-size: 13px;\r\n  font-weight: 800;\r\n  letter-spacing: 0.04em;\r\n  color: #0c6efd;\r\n  background: #e7f0ff;\r\n  padding: 5px 14px;\r\n  border-radius: 10px;\r\n}\r\n.bbp-wix-title { margin: 0 0 6px; font-size: 19px; font-weight: 700; color: var(--app-text); }\r\n.bbp-wix-text { margin: 0; font-size: 14px; line-height: 1.5; color: var(--app-text-muted); max-width: 560px; }\r\n.bbp-wix-status { display: flex; gap: 14px; }\r\n.bbp-wix-stat {\r\n  flex: 1 1 0;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n  padding: 14px 16px;\r\n  background: var(--app-bg);\r\n  border: 1px solid var(--app-border);\r\n  border-radius: 10px;\r\n}\r\n.bbp-wix-stat span { font-size: 11.5px; font-weight: 600; letter-spacing: 0.03em; text-transform: uppercase; color: var(--app-text-muted); }\r\n.bbp-wix-stat strong { font-size: 15px; color: var(--app-text); }\r\n.bbp-wix-btn {\r\n  flex: 0 0 auto;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 9px;\r\n  border: none;\r\n  background: var(--app-primary);\r\n  color: #fff;\r\n  font-family: inherit;\r\n  font-size: 14.5px;\r\n  font-weight: 700;\r\n  padding: 11px 26px;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  transition: background 0.15s var(--ease-smooth);\r\n}\r\n.bbp-wix-btn:hover:not(:disabled) { background: var(--app-primary-hover); }\r\n.bbp-wix-btn:disabled { opacity: 0.65; cursor: default; }\r\n.bbp-wix-btn svg { font-size: 12px; }\r\n\r\n/* Shared status pill (Wix view). */\r\n.bbp-status { display: inline-flex; align-items: center; gap: 7px; }\r\n.bbp-status-dot { width: 8px; height: 8px; border-radius: 50%; background: #9ca3af; flex: 0 0 auto; }\r\n.bbp-status.active .bbp-status-dot,\r\n.bbp-status.trialing .bbp-status-dot { background: #22c55e; }\r\n.bbp-status.ending .bbp-status-dot { background: #f59e0b; }\r\n.bbp-status.past-due .bbp-status-dot,\r\n.bbp-status.cancelled .bbp-status-dot { background: #ef4444; }\r\n.bbp-status.free .bbp-status-dot { background: #c4b5fd; }\r\n\r\n/* ── Not found ───────────────────────────────────────────────────────── */\r\n.bbp-notfound {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 14px;\r\n  padding: 60px 24px;\r\n  text-align: center;\r\n  color: var(--app-text-muted);\r\n}\r\n\r\n/* ── Responsive ──────────────────────────────────────────────────────── */\r\n@media (max-width: 720px) {\r\n  .rk-plans { grid-template-columns: 1fr; max-width: 420px; }\r\n  /* Stack the Wix header (button drops below the text, full-width) + the stats. */\r\n  .bbp-wix-head { flex-direction: column; align-items: stretch; gap: 16px; }\r\n  .bbp-wix-btn { justify-content: center; }\r\n  .bbp-wix-status { flex-direction: column; align-items: stretch; }\r\n}\r\n\r\n/* Shopify-managed billing: the Wix panel pattern with the Shopify badge color. */\r\n.bbp-wix-badge.bbp-badge-shopify { background: #e8f6ee; color: #157347; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
